var map = {
	"./adult/nn/readingtest-questions.json": 812,
	"./adult/no/readingtest-questions.json": 813,
	"./adult/se/readingtest-questions.json": 814,
	"./youth/de/readingtest-questions.json": 815,
	"./youth/nn/readingtest-questions.json": 816,
	"./youth/no/readingtest-questions.json": 817,
	"./youth/se/readingtest-questions.json": 818
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 811;